import { createActionGroup, emptyProps, props } from '@ngrx/store';
import type { EntityType } from '../../models/entity-type.model';

export const EntityTypesActions = createActionGroup({
  source: 'EntityTypes',
  events: {
    entity_types_required: emptyProps(),
    get_entity_types_start: emptyProps(),
    get_entity_types_success: props<{ types: Record<string, EntityType> }>()
  }
});
